import { Component, OnInit, ViewChild, ElementRef, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
declare var noUiSlider: any;
declare var wNumb: any;

@Component({
  selector: 'ngx-cm-range-slider',
  templateUrl: './ngx-cm-range-slider.component.html',
  styleUrls: ['./ngx-cm-range-slider.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgxCmRangeSliderComponent),
    multi: true
  }]
})
export class NgxCmRangeSliderComponent implements ControlValueAccessor, OnInit {
  @ViewChild('slider', { static: true, read: ElementRef }) Slider;

  @Input()
  Start;

  @Input()
  End;

  @Input()
  Min;

  @Input()
  Max;

  @Input()
  Step;

  onChange;

  constructor() { }

  ngOnInit() {
    noUiSlider.create(this.Slider.nativeElement, {
      start: this.End ? [this.Start ? this.Start : 0, this.End ? this.End : 0] : [this.Start ? this.Start : 0],
      // connect: true,
      range: {
        'min': this.Min ? this.Min == this.Max ? 0 : this.Min : 0,
        'max': this.Max ? this.Max : 0
      },
      format: {
        to: (value) => {
          return Math.round(value);
        },
        from: (value) => {
          return Math.round(value);
        }
      },
      step: this.Step
    }).on('change', (event) => {
      this.onChange(event);
    });
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) { }

  registerOnDisabledChange(fn) { }

  writeValue(value: Array<number>) {
    this.Slider.nativeElement.noUiSlider.set([value[0], value[1]]);
  }

}
